export default __webpack_public_path__ + "static/media/RAPPORT GENERAL ANNUEL DES ACTIVITES 2021.1de6a8c2.pdf";